export { default } from "./InputTags"
